/* eslint-disable @typescript-eslint/no-explicit-any */
import { globals } from "@/main";
import { requestHeaders } from "../requests/header.request";
import { api } from "@/dto/api.endpoint.dto";
import {
  apiErrorResponse,
  apiSuccessResponse,
} from "@/services/requests/response.request";

export const listMasterDataService = async (): Promise<any> => {
  const headers = await requestHeaders();

  return await globals.$axios
    .get(api.listMasterData, {
      headers,
    })
    .then((response: any) => {
      return apiSuccessResponse(response);
    })
    .catch((error: any) => {
      return apiErrorResponse(error);
    });
};
